import React from 'react';
import FAQ from '../../FAQ';
import list from './data';

export default function Faq() {
  return <FAQ questions={list} />;
}
